import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { StringRequest } from "../../../services/StringRequest";
import { SysAdminService } from "../../../services/sysadmin.service";
import { UserGroupInsertRequest } from "../../../services/UserGroupInsertRequest";

@Component({
	selector: "app-usergroup-add-user-group",
	templateUrl: "./add-user-group.component.html",
	styleUrls: ["./add-user-group.component.css"],
})
export class UserGroupAddUserGroupComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private sysAdminService: SysAdminService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.AllowDistrictGroups = this.dialogConfig.data.AllowDistrictGroups;
		this.CurrentUserLevel = this.dialogConfig.data.CurrentUserLevel;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		this.loadUserLevels();
	}

	//////////////////////////////////
	// Data
	//////////////////////////////////
	AllowDistrictGroups: boolean = false;
	CurrentUserLevel: any = -1;
	SchoolID: any = 0;

	Code: any = "";
	Desc: any = "";

	lstUserLevels: any = [];
	SelectedUserLevel: any = 0;

	AllSchools: any = false;

	errorMessage: any = "";

	//////////////////////////////////

	//////////////////////////////////
	// Load Data
	//////////////////////////////////

	loadUserLevels() {
		var result = this.sysAdminService.UserLevelGetList();
		result.subscribe(
			(response) => {
				this.lstUserLevels = response;

				if (this.AllowDistrictGroups == false) {
					this.lstUserLevels = this.lstUserLevels.filter((level: any) => level.UserLevelID == 3);
				}

				this.SelectedUserLevel = this.lstUserLevels[0].UserLevelID;
			},
			(error) => {}
		);
	}

	IsDistrictUser() {
		return this.CurrentUserLevel == 1;
	}

	//////////////////////////////////

	//////////////////////////////////
	// Buttons
	//////////////////////////////////
	onUpdate() {
		this.errorMessage = "";

		//Error handling
		if (this.Code == undefined || this.Code == "") {
			this.errorMessage = "Enter a Code";
			return;
		}

		if (this.Code.length < 3) {
			this.errorMessage = "Code must be at least 3 characters";
			return;
		}

		if (this.Desc == undefined || this.Desc == "") {
			this.errorMessage = "Enter a Description";
			return;
		}

		if (this.Desc.length < 3) {
			this.errorMessage = "Description must be at least 3 characters";
			return;
		}

		//Code and Description must be unique
		this.CheckCode();
	}

	CheckCode() {
		let parms: StringRequest = {
			str: this.Code,
		};

		var result = this.sysAdminService.GroupCodeInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Code already in use";
					return;
				} else {
					this.CheckDesc();
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringRequest = {
			str: this.Desc,
		};

		var result = this.sysAdminService.GroupDescInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Description already in use";
					return;
				} else {
					this.AddUserGroup();
				}
			},
			(error) => {}
		);
	}

	AddUserGroup() {
		var sID = this.SchoolID;

		if (this.AllSchools == true) {
			sID = -1;
		}

		let parms: UserGroupInsertRequest = {
			UserLevelID: this.SelectedUserLevel,
			DistrictID: -1,
			SchoolID: sID,
			UserGroupCD: this.Code,
			UserGroupDesc: this.Desc,
		};

		var result = this.sysAdminService.UserGroupInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "User Group was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not create the User Group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////
}
